module.exports = __webpack_public_path__ + "img/player.9f3ba91e.png";